module.exports = __webpack_public_path__ + "static/media/icon7.1d19f72d.svg";